<template lang="pug">
  .map-milestones
    BCollapse.card.milestones-container.mb-5(
      aria-id="milestones"
      :open.sync="milestonesOpen"
      animation=""
    )
      .card-header(
        slot='trigger'
        role='button'
      )
        .title-container
          BIcon(:icon="milestonesOpen ? 'chevron-up mdi-24px' : 'chevron-down mdi-24px'")
          .view-milestones-trigger-text.is-family-primary View Milestones
      .milestone-container(v-for="milestone in milestones" :key="milestone.id")
        .milestone-icon
          BIcon(icon="map-marker" type="is-danger")
        .milestone-title.is-family-secondary {{ milestone.title }}
        .milestone-description.is-family-primary {{ milestone.description }}
</template>

<script>
import { mapActions } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtButton from "@@/WtButton/WtButton";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "MapMilestones",

  components: { WtButton, WtSvgIcon, WtTitle },

  mixins: [dateUtilityMixin],

  props: {
    mapId: {
      type: Number,
      default: null,
      required: true
    }
  },

  data() {
    return {
      milestonesOpen: false,
      milestones: []
    };
  },
  async mounted() {
    let response = await this.mapMilestones(this.mapId);
    if (response && response.data && response.data.length) {
      this.milestones = response.data;
    }
  },

  methods: {
    ...mapActions("program", ["mapMilestones"])
  }
};
</script>

<style lang="sass">
.milestones-container
  background-color: $grey-lighter
  padding: 15px 20px
  width: 500px
  .title-container
    display: flex
    align-items: center
  .card-header
    box-shadow: none
  .view-milestones-trigger-text
    font-size: 16px
  #milestones
    margin-top: 20px
  .milestone-container
    margin-top: 10px
    border-left: 1px solid $grey-light
    padding-left: 20px
    position: relative
    .milestone-title
      font-size: 16px
    .milestone-description
      font-size: 14px
    .milestone-icon
      position: absolute
      left: -12px
      background-color: $grey-lighter
</style>
